export const SEARCHING = "SEARCHING"
export const NOT_SEARCHING = "NOT_SEARCHING"
